import React, { useEffect, useMemo, useState } from "react";
import Header from "../Header";
import PolicyholderForm from "../components/PolicyholderForm";
import FormWizard from "../components/FormWizard";
import { ThemeProvider, styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { Grid, Paper, Typography } from "@mui/material";
import PolicyholderUploadDocs from "../components/PolicyholderUploadDocs";
import PolicyholderReview from "../components/PolicyholderReview";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  createContribtionPolicyholder,
  documentFileCreate,
  documentFileSearch,
  documentTemplate,
  documentsSearch,
  fetchContributionPlanByID,
  fetchPolicyHolderInfo,
  loadingUser,
  loginCnss,
  replacePolicyHolderContributionPlanBundle,
  updatePolicyholderUser,
} from "../action";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import { formatDateFromISO } from "../utils/helper";
import PolicyholderValidation from "../components/PolicyholderValidation";
import { useForm } from "react-final-form";
import { GedToken } from "../utils/constant";

function PolicyHolder() {
  const [activeStep, setactiveStep] = useState(0);
  const [documentDetails, setDocumentDetails] = useState(0);
  const [fetchPolicyholdr, setFetchPolicyholdr] = useState(false);
  const [formvalue, setFormvalue] = useState({});
  const navigate = useNavigate();
  const { t } = useTranslation();
  const userData = useSelector((state) => state.profileReducer);
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const policyholderUserData =
    userData?.policyholderUserResponseData?.[0]?.policyHolder;

  const GedTokenDocs = localStorage.getItem("GED_token");

  useEffect(() => {
    // const handleDocumentAPIs = async () => {
    if (GedTokenDocs) {
      dispatch(documentTemplate("Employer Registration"));
      if (policyholderUserData) {
        dispatch(documentFileSearch(policyholderUserData));
        dispatch(documentsSearch(policyholderUserData));
      }
    }
  }, [GedTokenDocs]);

  useEffect(() => {
    if (userData?.currentUserResponseData?.id) {
      dispatch(fetchPolicyHolderInfo(userData?.currentUserResponseData?.id));
    }
    dispatch(loadingUser(token));

    if (policyholderUserData?.id) {
      dispatch(fetchContributionPlanByID(policyholderUserData?.id));
      // unwrapJSONFields(policyholderUserData);
    }
  }, [userData?.currentUserResponseData?.id, policyholderUserData?.id]);

  useEffect(() => {
    loginCnss();
  }, []);

  useEffect(() => {
    if (!!fetchPolicyholdr) {
      dispatch(fetchPolicyHolderInfo(userData?.currentUserResponseData?.id));
    }
  }, [fetchPolicyholdr]);

  const handleNavigation = (path, state) => {
    navigate(path, state);
  };

  const onSubmit = async (values) => {
    const res = await dispatch(
      updatePolicyholderUser(
        values,
        policyholderUserData,
        activeStep,
        handleNavigation,
        userData?.currentUserResponseData?.id
      )
    );
    setFetchPolicyholdr(true);
    dispatch(fetchPolicyHolderInfo(userData?.currentUserResponseData?.id));
  };
  const StyledStepLabel = styled(StepLabel)(({ theme }) => ({
    "& .MuiStepLabel-icon": {
      display: "none",
    },
  }));
  const QontoConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 10,
      left: "calc(-51.5% + 16px)",
      right: "calc(48% + 16px)",
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: "#00913e",
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: "#00913e",
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      borderColor:
        theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
      borderTopWidth: 3,
      borderRadius: 1,
    },
  }));

  const onNextClickForm = async (values) => {
    if (activeStep == 1) {
      dispatch(documentFileCreate(userData?.fileData));
      const response = await dispatch(
        updatePolicyholderUser(
          values,
          policyholderUserData,
          activeStep,
          handleNavigation,
          userData?.currentUserResponseData?.id
        )
      );
      setFetchPolicyholdr(true);
      dispatch(fetchPolicyHolderInfo(userData?.currentUserResponseData?.id));
    } else {
      const response = await dispatch(
        updatePolicyholderUser(
          values,
          policyholderUserData,
          activeStep,
          handleNavigation,
          userData?.currentUserResponseData?.id
        )
      );
      if (userData?.mutations?.[0].error == null) {
        if (
          !userData?.contributionPlanByIdResponseData?.[0]
            ?.contributionPlanBundle
        ) {
          const responseContribution = await dispatch(
            createContribtionPolicyholder(values, policyholderUserData)
          );
        } else {
          if (
            userData?.contributionPlanByIdResponseData?.[0]
              ?.contributionPlanBundle?.id !== values.contributionPlanBundle
          ) {
            await dispatch(
              replacePolicyHolderContributionPlanBundle(
                values,
                userData?.contributionPlanByIdResponseData?.[0]
              )
            );
          }
        }
      }
      setFetchPolicyholdr(true);
      dispatch(fetchPolicyHolderInfo(userData?.currentUserResponseData?.id));
      dispatch(fetchContributionPlanByID(policyholderUserData?.id));
    }
  };

  const initialValuesData = !!userData?.policyholderUserResponseData &&
    !!policyholderUserData && {
      ...policyholderUserData,
      dateValidFrom:
        policyholderUserData?.dateValidFrom &&
        formatDateFromISO(policyholderUserData?.dateValidFrom),
      address:
        policyholderUserData?.address &&
        JSON.parse(policyholderUserData?.address).address,
      mainActivity:
        (!!policyholderUserData?.jsonExt &&
          !!JSON.parse(policyholderUserData?.jsonExt).jsonExt.mainActivity &&
          JSON.parse(policyholderUserData?.jsonExt).jsonExt.mainActivity) ||
        "",
      createdAt:
        policyholderUserData?.jsonExt &&
        !!JSON.parse(policyholderUserData?.jsonExt).jsonExt.createdAt &&
        JSON.parse(policyholderUserData?.jsonExt).jsonExt.createdAt.code,
      shortName:
        policyholderUserData?.jsonExt &&
        JSON.parse(policyholderUserData?.jsonExt).jsonExt.shortName,
      rccm:
        (policyholderUserData?.jsonExt &&
          !!JSON.parse(policyholderUserData?.jsonExt).jsonExt.rccm &&
          JSON.parse(policyholderUserData?.jsonExt).jsonExt.rccm) ||
        "",
      niu:
        (!!policyholderUserData?.jsonExt &&
          !!JSON.parse(policyholderUserData?.jsonExt).jsonExt.niu &&
          JSON.parse(policyholderUserData?.jsonExt).jsonExt.niu) ||
        "",
      nbEmployees:
        (policyholderUserData?.jsonExt &&
          !!JSON.parse(policyholderUserData?.jsonExt).jsonExt.nbEmployees &&
          JSON.parse(policyholderUserData?.jsonExt).jsonExt.nbEmployees) ||
        "",
      bank:
        policyholderUserData?.bankAccount &&
        JSON.parse(policyholderUserData?.bankAccount).bankAccount.bank,
      bankCode:
        policyholderUserData?.bankAccount &&
        JSON.parse(policyholderUserData?.bankAccount).bankAccount.bank,
      lockerCode:
        policyholderUserData?.bankAccount &&
        JSON.parse(policyholderUserData?.bankAccount).bankAccount.lockerCode,
      accountNb:
        policyholderUserData?.bankAccount &&
        JSON.parse(policyholderUserData?.bankAccount).bankAccount.accountNb,
      bankKey:
        policyholderUserData?.bankAccount &&
        JSON.parse(policyholderUserData?.bankAccount).bankAccount.bankKey,
      contactName:
        policyholderUserData?.contactName &&
        JSON.parse(policyholderUserData?.contactName).contactName,
      village:
        policyholderUserData?.locations && policyholderUserData?.locations.id,
      municipality:
        policyholderUserData?.locations?.parent &&
        policyholderUserData?.locations?.parent?.uuid,
      city:
        policyholderUserData?.locations &&
        policyholderUserData?.locations?.parent?.parent.uuid,
      region:
        policyholderUserData?.locations &&
        policyholderUserData?.locations?.parent?.parent?.parent.uuid,
      contributionPlanBundle:
        userData?.contributionPlanByIdResponseData?.[0]
          ?.contributionPlanBundle &&
        userData?.contributionPlanByIdResponseData?.[0]?.contributionPlanBundle
          ?.id,
    };
  // const initialValuesData={}

  const steps = [
    t("General Information"),
    t("Upload Documents"),
    t("Review & Submit"),
  ];
  const stepsPending = [
    t("Application Submitted"),
    t("Review Pending"),
    t("Approved"),
  ];
  return (
    <Header policyholderPage>
     {!!policyholderUserData ?  !!policyholderUserData?.isSubmit ? (
        <div>
          <Typography
            variant="h5"
            sx={{
              display: "flex",
              fontWeight: "bold",
              justifyContent: "center",
            }}
          >
            {t("policyholderPendingTitle")}
          </Typography>
          <Typography
            variant="h5"
            sx={{
              display: "flex",
              fontWeight: "bold",
              justifyContent: "center",
            }}
          >
            {t("policyholderRequestNo")} {policyholderUserData?.requestNumber}
          </Typography>
          <Stack sx={{ width: "50%" }} className="mx-auto">
            <Stepper
              alternativeLabel
              activeStep={!!policyholderUserData?.isApproved ? 3 : 1}
              connector={<QontoConnector />}
            >
              {stepsPending.map((label) => (
                <Step key={label}>
                  <StyledStepLabel color="primary">{t(label)}</StyledStepLabel>
                </Step>
              ))}
            </Stepper>
          </Stack>
          <PolicyholderReview phId={policyholderUserData} />
        </div>
      ) : (
        <>
          <div display="flex">
            <Typography
              variant="h5"
              component="span"
              sx={{ marginLeft: "1.5rem", fontWeight: "bold" }}
            >
              {t("policyholderTitle")}
            </Typography>
            <Stack
              sx={{ width: "50%", float: "right", display: "inline-flex" }}
              component="span"
              spacing={10}
            >
              <Stepper
                alternativeLabel
                activeStep={!!activeStep ? activeStep : 0}
                // connector={<StyledStepConnector />}
                connector={<QontoConnector />}
              >
                {steps.map((label) => (
                  <Step key={label}>
                    <StyledStepLabel color="primary">
                      {t(label)}
                    </StyledStepLabel>
                  </Step>
                  // <Step key={label}>
                  //   <StepLabel>{label}</StepLabel>
                  // </Step>
                ))}
              </Stepper>
            </Stack>
          </div>
          <FormWizard
            onSubmit={onSubmit}
            setactiveStep={setactiveStep}
            onNextClickForm={onNextClickForm}
            initVal={initialValuesData}
            validate={PolicyholderValidation}
            documentDetails={documentDetails}
            t={t}
          >
            <FormWizard.Page validate={PolicyholderValidation}>
              {!!initialValuesData ? (
                <PolicyholderForm
                  onSubmit={onSubmit}
                  policyholderUserData={policyholderUserData}
                  setFormvalue={setFormvalue}
                />
              ) : (
                <>
                  <Loader />
                </>
              )}
            </FormWizard.Page>
            <FormWizard.Page>
              <PolicyholderUploadDocs
                phId={policyholderUserData}
                setDocumentDetails={setDocumentDetails}
              />
            </FormWizard.Page>
            <FormWizard.Page>
              <PolicyholderReview phId={policyholderUserData} />
            </FormWizard.Page>
          </FormWizard>
        </>
      ):""}
    </Header>
  );
}

export default PolicyHolder;
